import React from 'react';

import Contact from '../components/Pages/Contact';

const ContactPage = ({ data: { allContentfulContactPage: { edges } } }) => {
  return <Contact data={edges[0].node} />;
};

export default ContactPage;

export const frContactQuery = graphql`
  query FrContactQuery {
    allContentfulContactPage(filter: { node_locale: { eq: "fr" } }) {
      edges {
        node {
          node_locale
          contactTitle
          metaDescription
          findUsBannerTitle
          findUsBannerAddress
          headerImage {
            title
            sizes(quality: 100) {
              base64
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
            }
            file {
              url
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.fr.js